import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Mail, Globe } from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  {/*const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/contact`, formData);

      if (response.data.success) {
        toast.success(response.data.message);
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Contact form error:', error);
      toast.error('Failed to submit form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };*/}

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch("https://formspree.io/f/meerlndp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        toast.success("Form submitted successfully!");
        setFormData({ name: "", email: "", company: "", message: "" });
      } else {
        toast.error("Failed to send message.");
      }

    } catch (error) {
      console.error(error);
      toast.error("Something went wrong.");
    }

    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="py-16 bg-[#0B0F14] relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-10 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-white font-['Qurova',sans-serif]">
            Get <span className="text-[#3DF2E0]">In Touch</span>
          </h2>
          {/*<p className="text-2xl text-[#9CA3AF] font-['League_Spartan'] max-w-2xl mx-auto">
            Ready to transform your business with AI? Let's discuss your automation needs
          </p>*/}
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-6">
            <div className="bg-[#0B0F14] border border-[#1F2933] rounded-md p-8">
              <h3 className="text-2xl font-semibold text-white font-['Qurova',sans-serif] mb-6">
                Contact Information
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-md border border-[#3DF2E0] flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-[#3DF2E0]" />
                  </div>
                  <div>
                    <div className="text-base text-[#9CA3AF] font-['League_Spartan'] mb-1">Email</div>
                    <a
                      href="mailto:nidish@theaikompany.com"
                      className="text-lg text-white font-['League_Spartan'] hover:text-[#3DF2E0] transition-colors duration-200"
                    >
                      enquiry@theaikompany.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-md border border-[#3DF2E0] flex items-center justify-center flex-shrink-0">
                    <FaWhatsapp className="w-6 h-6 text-[#3DF2E0]" />
                  </div>
                  <div>
                    <div className="text-base text-[#9CA3AF] font-['League_Spartan'] mb-1">Whatsapp</div>
                    <a
                      href="https://wa.me/message/PMTL7OICK6OUG1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-lg text-white font-['League_Spartan'] hover:text-[#3DF2E0] transition-colors duration-200"
                    >
                      +91 9619612063
                    </a>
                  </div>
                </div>

                {/* Socials Info */}
                <h3 className="text-2xl font-semibold text-white font-['Qurova',sans-serif] mb-6">
                  Socials
                </h3>
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-md border border-[#3DF2E0] flex items-center justify-center flex-shrink-0">
                      <FaInstagram className="w-6 h-6 text-[#3DF2E0]" />
                    </div>
                    <div>
                      <div className="text-base text-[#9CA3AF] font-['League_Spartan'] mb-1">Instagram</div>
                      <a
                        href="https://www.instagram.com/the_ai_kompany?igsh=NGloaHIzeml3YjVl&utm_source=qr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-lg text-white font-['League_Spartan'] hover:text-[#3DF2E0] transition-colors duration-200"
                      >
                        Instagram@the_ai_kompany
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 rounded-md border border-[#3DF2E0] flex items-center justify-center flex-shrink-0">
                      <FaLinkedin className="w-6 h-6 text-[#3DF2E0]" />
                    </div>
                    <div>
                      <div className="text-base text-[#9CA3AF] font-['League_Spartan'] mb-1">Email</div>
                      <a
                        href="https://www.linkedin.com/company/the-ai-kompany"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-lg text-white font-['League_Spartan'] hover:text-[#3DF2E0] transition-colors duration-200"
                      >
                        LinkedIn@theaikompany
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* Terminal Easter Egg Hint */}
              <div className="bg-[#0B0F14] border border-[#1F2933] rounded-md p-6">
                <div className="font-['JetBrains_Mono',monospace] text-xs text-[#3DF2E0] space-y-1">
                  <div className="text-[#9CA3AF]">// Hidden Feature</div>
                  <div>Press <span className="bg-[#3DF2E0]/10 px-2 py-0.5 rounded border border-[#3DF2E0]/30">CTRL + K</span></div>
                  <div className="text-[#9CA3AF]">// to access terminal</div>
                </div>
              </div>
            </div>
          </div>
          {/* Contact Form - Terminal Style */}
          <div className="bg-[#0B0F14] border border-[#3DF2E0] rounded-md p-8">
            {/* Terminal Header */}
            <div className="flex items-center space-x-2 mb-6 pb-4 border-b border-[#1F2933]">
              <div className="flex space-x-1.5">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
              </div>
              <div className="text-sm font-['JetBrains_Mono',monospace] text-[#9CA3AF]">
                contact_form.terminal
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-['JetBrains_Mono',monospace] text-[#3DF2E0] mb-2">
                  &gt; name:
                </label>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="bg-[#0B0F14] border-[#1F2933] text-white font-['JetBrains_Mono',monospace] focus:border-[#3DF2E0] rounded-md"
                  placeholder="Enter your name"
                />
              </div>

              <div>
                <label className="block text-sm font-['JetBrains_Mono',monospace] text-[#3DF2E0] mb-2">
                  &gt; email:
                </label>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="bg-[#0B0F14] border-[#1F2933] text-white font-['JetBrains_Mono',monospace] focus:border-[#3DF2E0] rounded-md"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label className="block text-sm font-['JetBrains_Mono',monospace] text-[#3DF2E0] mb-2">
                  &gt; company:
                </label>
                <Input
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="bg-[#0B0F14] border-[#1F2933] text-white font-['JetBrains_Mono',monospace] focus:border-[#3DF2E0] rounded-md"
                  placeholder="Your company name"
                />
              </div>

              <div>
                <label className="block text-sm font-['JetBrains_Mono',monospace] text-[#3DF2E0] mb-2">
                  &gt; message:
                </label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  className="bg-[#0B0F14] border-[#1F2933] text-white font-['JetBrains_Mono',monospace] focus:border-[#3DF2E0] rounded-md resize-none"
                  placeholder="Tell us about your project..."
                />
              </div>

              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#0B0F14] text-[#3DF2E0] border-2 border-[#3DF2E0] hover:bg-[#3DF2E0] hover:text-[#0B0F14] transition-all duration-300 rounded-md py-6 font-['JetBrains_Mono',monospace]"
              >
                {isSubmitting ? '> Sending...' : '> Submit Form'}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
